import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { injectIntl } from 'react-intl'
import Typography from '@material-ui/core/Typography'
import { Container, Grid } from '@material-ui/core'
import EmptyChart from './EmptyChart'
import barChartImage from '../../../../assets/bar-chart.svg'
import lineChartImage from '../../../../assets/line-chart.svg'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
	titleRoot: {
		flexGrow: 1,
		width: '100%',
		color: 'white',
		fontSize: '35px',
		paddingTop: '16px',
		letterSpacing: '0.25px',
		textAlign: 'center',
		
		[theme.breakpoints.down('sm')]: {
            margin: '0 -16px',
			width: 'calc(100% + 32px)',
        },
	},
	root: {
		flexGrow: 1,
		width: '100%',
		backgroundColor: '#11121C',
		color: 'white',
		fontSize: '1.2em',
		paddingTop: '16px',
		
		[theme.breakpoints.down('sm')]: {
            margin: '0 -16px',
			width: 'calc(100% + 32px)',
        },
	},
	gridInner: {
		padding: '0',
		margin: '0 -24px',
		width: 'calc(100% + 24px)',
		[theme.breakpoints.down('sm')]: {
            margin: '-12px -40px 0 -40px',
			width: '100vw',
        },
	},
	chartGraph: {
		flex: 1,
		[theme.breakpoints.down('sm')]: {
			flex: 1,
        },
	},
	barChartImage: {
		position: 'absolute',
		left: '46%',
		top: '600px'
	},
	lineChartImage: {
		position: 'absolute',
		left: '49%',
		top: '620px'
	}
}))

const EmptySurvey = ({ intl }) => {
	const classes = useStyles()

	return (
		<div>
			<Container maxWidth="lg">
				<Grid data-testid="empty-survey" container alignItems="center" justify="center" >
					<Grid item xs={12} sm={6}>
						<Typography variant='h4' className={classes.titleRoot}>
							{intl.formatMessage({ id: 'app.dashboard.noResults' })}
						</Typography>
					</Grid>
					<Grid item xs={12}>
						<div className={classes.root}>
							<Grid container direction='column' alignItems='center'>
								<Grid container className={classes.gridInner}>
									<Grid data-testid="empty-chart" item className={clsx(classes.chartGraph, `chartGraph`)}>
										<EmptyChart />
										<img alt="No Chart Image" src={barChartImage} className={classes.barChartImage} />
										<img alt="No Chart Image" src={lineChartImage} className={classes.lineChartImage} />
									</Grid>
								</Grid>
							</Grid>
						</div>
					</Grid>
				</Grid>
			</Container>
		</div>
	)
}

const mapStateToProps = () => ({})

const mapDispatchToProps = () => ({})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)

export default enhance(EmptySurvey)
